import React from "react";
import ImageUpload from "../../../ui/imageUpload/ImageUpload";
import ScheduleFooter from "../scheduleFooter/ScheduleFooter";
import classes from "./ScheduleTabContent.module.css";

const ScheduleTabContentUI = ({ texts = {}, imageFile, onImageChange, hasImage, pendingDelete, publishDisabled, isSubmitting, onClose, onSave, maxSizeBytes }) => (

    <div className={classes.TabPanelRoot}>
        <div className={classes.Form}>
            <div className={classes.PreviewBox}>
                <ImageUpload
                    imageFile={imageFile}
                    onImageChange={onImageChange}
                    removeAriaLabel={texts.scheduleDeleteImage}
                    maxSizeBytes={maxSizeBytes}
                    bannerKey="imageUploadRecommendation"
                />
            </div>
        </div>
        <ScheduleFooter texts={texts} hasImage={hasImage} pendingDelete={pendingDelete} publishDisabled={publishDisabled} isSubmitting={isSubmitting} onClose={onClose} onSave={onSave} />
    </div>
);

export default ScheduleTabContentUI;
